// toastHelpers.js
import React from "react";

import { toast } from "react-toastify";
import ToastMessage from "../Manager/ToastMessage";

export const showSuccessToast = (title, message) => {
  toast(
    <ToastMessage title={title} message={message} />,
    {
      position: "top-right",
      autoClose: 2000,
      closeButton: false,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: true,
      zIndex: 900000,
      style: {
        right: "87px",
        top: "56px",
        marginRight: "20px",
        backgroundColor: "transparent",
        boxShadow: "none",
        width: "510px",
      },
    }
  );
};
